import {
  Button,
  DateRangeSelector,
  Dropdown,
  DropdownItem,
  DropdownList,
  ENUM_DATE_RANGE,
  Table,
  TableData,
  TableRow,
  getDateRangeSelector
} from '@cokitchen/cokitchen-components';
import { AddIcon, FilterAltIcon, DeleteIcon, ArrowRightIcon } from 'cokitchen-icons';
import { ReactComponent as GiftIcon } from 'assets/icons/gift.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg';
import React, { useEffect, useState } from 'react';
import './styles.scss';
import MemberStatus from 'components/base/member-status';
import DeletePeople from 'components/modals/delete-people-modal';
import MemberDetails from 'components/modals/member-details';
import PeopleTableBulkActions from './people-table-bulk-actions';
import { apiService } from 'services/base.service';
import useDashboardContext from 'contexts/dashboard.context';
import { Link, useSearchParams } from 'react-router-dom';
import PageHeader from 'components/base/page-header';
import BudgetSettingModal, { UpdateMemberPayload } from 'components/modals/budget-settings-modal';
import GiftSelectedMemberModal from 'components/modals/gift-selected-member-modal';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { cleanObject, formatCurrency, getFullName, handleApiError } from 'utils/functions';
import { ENUM_MEMBER_FILTER_LIST } from 'utils/enum';
import SearchInput from 'components/base/search-input';
import PageLoader from 'components/base/page-loader';
import { MemberListType } from 'models/member.model';
import { DepartmentType } from 'models/department.model';
export type TableProps = {
  name: string;
  dept: string;
  birthday: string;
  status: string;
  phone: string;
  budget: string;
  available_budget: string;
  budget_settings: string;
  id: number;
};

const filterList = [
  ENUM_MEMBER_FILTER_LIST.ALL,
  ENUM_MEMBER_FILTER_LIST.TOP_SPENDERS,
  ENUM_MEMBER_FILTER_LIST.LEAST_ORDERS,
  ENUM_MEMBER_FILTER_LIST.RECENTLY_ADDED,
  ENUM_MEMBER_FILTER_LIST.JOINED,
  ENUM_MEMBER_FILTER_LIST.PENDING_INVITE
];

const tableHeaders = [
  'Name',
  'Dept',
  'Status',
  'Phone no.',
  'Budget',
  'Available budget',
  'Budget setting',
  'Budget duration',
  ''
];
const People = () => {
  const [searchParams] = useSearchParams();
  const [filter, setFilter] = useState(getDateRangeSelector(ENUM_DATE_RANGE.ALL));
  const [selectedPeople, setSelectedPeople] = useState<MemberListType[]>([]);
  const [peopleArray, setPeopleArray] = useState<MemberListType[]>([]);
  const [filteredPeople, setFilteredPeople] = useState<MemberListType[]>([]);
  const [showDepartmentList, setShowDepartmentList] = useState<boolean>(false);
  const [showFilterList, setShowFilterList] = useState<boolean>(false);
  const [filterValue, setFilterValue] = useState<string>(ENUM_MEMBER_FILTER_LIST.ALL);
  const [singlePeople, setSinglePeople] = useState<MemberListType>();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [activeMember, setActiveMember] = useState<MemberListType | null>(null);
  const [showBudgetSettingsModal, setShowBudgetSettingsModal] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const [showBulkActions, setShowBulkActions] = useState<boolean>(true);
  const [departmentFilterList, setDepartmentFilterList] = useState<DepartmentType[]>([]);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [total, setTotal] = useState(0);
  const { activeCompany, setIsBackLink } = useDashboardContext();
  const companyId = activeCompany?.id;

  const getDepartments = async () => {
    if (!companyId) return;
    try {
      const res = await apiService.get(`department/company/${companyId}`);
      setDepartmentFilterList(res?.data?.data);
    } catch (err) {
      handleApiError(err);
    }
  };

  useEffect(() => {
    getDepartments();
  }, [companyId]);

  const fetchAllMembersList = async () => {
    if (!companyId) return;
    const data: Record<string, unknown> = {
      company_id: companyId,
      department_id: '',
      recent: false,
      top_spender: false,
      least_order: false,
      page: pageNumber,
      start_date: filter.startDate,
      end_date: filter.endDate,
      search_text: searchText
    };
    if (filterValue === ENUM_MEMBER_FILTER_LIST.ALL) {
      data.recent = false;
      data.top_spender = false;
      data.least_order = false;
    } else if (filterValue === ENUM_MEMBER_FILTER_LIST.TOP_SPENDERS) {
      data.top_spender = true;
    } else if (filterValue === ENUM_MEMBER_FILTER_LIST.LEAST_ORDERS) {
      data.least_order = true;
    } else if (filterValue === ENUM_MEMBER_FILTER_LIST.RECENTLY_ADDED) {
      data.recent = true;
    } else if (filterValue === ENUM_MEMBER_FILTER_LIST.JOINED) {
      data.joined = true;
    } else if (filterValue === ENUM_MEMBER_FILTER_LIST.PENDING_INVITE) {
      data.joined = false;
    } else {
      data.department_id = selectedDepartmentId;
    }
    try {
      setLoading(true);
      const res = await apiService.get('member', { params: cleanObject(data) });
      if (res) {
        setPeopleArray(res?.data?.data?.results);
        setFilteredPeople(res?.data?.data?.results);
        setTotal(res?.data?.data?.total);
        const totalNoOfPages = Math.ceil(res?.data?.data?.total / 40);
        setPageCount(totalNoOfPages);
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const getSelectedPage = async (val: { selected: number }) => {
    const pageNo = val?.selected + 1;
    setPageNumber(pageNo);
  };

  useEffect(() => {
    if (companyId) fetchAllMembersList();
  }, [companyId, filterValue, selectedDepartmentId, pageNumber, filter, searchText]);

  useEffect(() => {
    getSelectedPage({ selected: 0 });
    setIsBackLink(false);
  }, []);
  useEffect(() => {
    if (selectedPeople.length > 1) {
      setShowBulkActions(true);
    } else {
      setShowBulkActions(false);
    }
  }, [selectedPeople]);

  const isAllSelected = () => {
    return peopleArray.length === selectedPeople.length;
  };

  const selectPeople = (id: string) => {
    const people = filteredPeople.find((member) => member.id === id);

    if (people) {
      if (selectedPeople.includes(people)) {
        setSelectedPeople((prevItem: MemberListType[]) =>
          prevItem.filter((people) => people.id !== id)
        );
      } else {
        setSelectedPeople((prevItem: MemberListType[]) => [...prevItem, people]);
      }
    }
  };

  const toggleAll = () => {
    setSelectedPeople(filteredPeople);
  };
  useEffect(() => {
    if (selectedPeople === filteredPeople) {
      isAllSelected();
    }
    if (selectedPeople.length) {
      setActiveMember(null);
    }
  }, [selectedPeople]);

  const handleEditPeople = (people: MemberListType) => {
    setShowDetailModal(true);
    setSinglePeople(people);
  };
  const handleGiftMemeber = (people: MemberListType) => {
    setShowGiftModal(true);
    setSinglePeople(people);
  };
  const handleDelete = () => {
    setShowDeleteModal(true);
  };

  useEffect(() => {
    const selectedPeopleJSON = JSON.stringify(selectedPeople);
    localStorage.setItem(STORAGE_KEYS.SELECTED_PEOPLE, selectedPeopleJSON);
  }, [selectedPeople]);

  const updatePerson = (newData: MemberListType) => {
    setFilteredPeople((prevPeople) => {
      return prevPeople.map((person) => (person.id === singlePeople?.id ? newData : person));
    });
  };

  const updateMembers = (payload: UpdateMemberPayload) => {
    const { budget, budgetDuration: budget_duration, budgetSetting: budget_setting } = payload;
    const selectedPeopleIds = selectedPeople.map((person) => person.id);
    setFilteredPeople((prevPeople) => {
      return prevPeople.map((person) =>
        selectedPeopleIds.includes(person.id)
          ? { ...person, budget, budget_duration, budget_setting }
          : person
      );
    });
  };

  const removeMembers = (ids: string[]) => {
    setFilteredPeople((prevPeople) => {
      return prevPeople.filter((person) => !ids.includes(person.id));
    });
    setTotal((prevTotal) => prevTotal - ids.length);
  };
  return (
    <div className='w-full people'>
      <PageHeader
        title={`Members (${total})`}
        subtitle='Manage and keep track of member’s information'>
        <Link
          to={
            searchParams.get('from') === ROUTE_KEYS.GET_STARTED
              ? '/add-people?from=get-started'
              : '/add-people'
          }>
          <Button variant='block' color='primary' className='w-[169px] text-white gap-1' small>
            <AddIcon className='w-5 h-5 text-white' />
            Add member
          </Button>
        </Link>
      </PageHeader>
      <div className='flex justify-between items-center flex-wrap gap-4 w-full mb-8 members_header'>
        <div className='flex gap-3 items-center sm:flex-wrap md:flex-nowrap w-full md:w-fit'>
          <div className='w-full max-w-[235px] min-w-[150px] h-[36px]'>
            <DateRangeSelector
              defaultRange={ENUM_DATE_RANGE.ALL}
              onChange={(v) => setFilter(v.date)}
              className='h-[36px] text-[#5E6164] border-[#E5E6E6]'
            />
          </div>
          <div>
            <Dropdown
              visible={showFilterList}
              onClickOutside={() => setShowFilterList(false)}
              content={
                <div
                  className='flex justify-between items-center min-w-[150px] border border-[#E5E6E6] rounded-md p-2 text-[#5E6164] text-sm gap-2 cursor-pointer h-[36px]'
                  onClick={() => setShowFilterList(true)}>
                  {filterValue || 'Sort'}
                  <FilterAltIcon />
                </div>
              }>
              <DropdownList>
                <DropdownItem>
                  <Dropdown
                    visible={showDepartmentList}
                    onClickOutside={() => {
                      setShowDepartmentList(false);
                      setShowFilterList(false);
                    }}
                    placement='right'
                    content={
                      <div
                        className='flex justify-between items-center w-full gap-6'
                        onClick={() => setShowDepartmentList(true)}>
                        <span className='text-[#2E3031]'>Departments</span>
                        <ArrowRightIcon />
                      </div>
                    }>
                    <DropdownList>
                      {departmentFilterList.map((item, index) => (
                        <DropdownItem
                          key={index}
                          onClick={() => {
                            setFilterValue(item.name);
                            setSelectedDepartmentId(item.id);
                            setShowDepartmentList(false);
                            setShowFilterList(false);
                          }}>
                          {item.name}
                        </DropdownItem>
                      ))}
                    </DropdownList>
                  </Dropdown>
                </DropdownItem>
                {filterList.map((item, index) => (
                  <DropdownItem
                    key={index}
                    onClick={() => {
                      setFilterValue(item);
                      setShowFilterList(false);
                    }}>
                    {item}
                  </DropdownItem>
                ))}
              </DropdownList>
            </Dropdown>
          </div>
        </div>
        <div className='h-[36px]'>
          <SearchInput value={searchText} handleChange={(e) => setSearchText(e.target.value)} />
        </div>
      </div>

      {loading ? (
        <div className='text-center mt-5'>
          <PageLoader />
        </div>
      ) : filteredPeople.length === 0 ? (
        <div className='text-sm text-center mt-5'>No members available</div>
      ) : (
        <Table
          loading={loading}
          headers={tableHeaders}
          canSelect
          isAllSelected={isAllSelected()}
          onToggleAll={toggleAll}
          pageCount={pageCount}
          onPageChange={getSelectedPage}>
          {filteredPeople.map((people) => (
            <TableRow
              key={people.id}
              canSelect
              isSelected={selectedPeople.includes(people)}
              onToggle={() => selectPeople(people.id)}
              className='hover:bg-[#F5F6F6] table_row'>
              <TableData>
                <p onClick={() => setShowDetailModal(true)} className='cursor-pointer capitalize'>
                  {getFullName(people.user)}
                </p>
              </TableData>
              <TableData>
                <p className='capitalize'>{people.department.name}</p>
              </TableData>
              <TableData>
                <MemberStatus status={people.status} />
              </TableData>
              <TableData>{people.user.phone_number}</TableData>
              <TableData>{formatCurrency(people.budget)}</TableData>
              <TableData>{formatCurrency(people.balance)}</TableData>
              <TableData>
                <p
                  className={`capitalize ${
                    people.budget_setting === 'ROLL OVER' ? 'text-[#0080E5]' : 'text-[#B26800]'
                  }`}>
                  {people.budget_setting?.toLocaleLowerCase() || '-'}
                </p>
              </TableData>
              <TableData>{people.budget_duration}</TableData>
              <TableData>
                <div className='w-[74px]'>
                  <div className={`gap-2 w-full ${showBulkActions ? 'hidden' : 'flex'}`}>
                    <GiftIcon
                      className='w-5 h-5 text-[#6F7376] icon'
                      onClick={() => {
                        handleGiftMemeber(people);
                      }}
                    />
                    <EditIcon
                      className='w-5 h-5 text-[#6F7376] icon'
                      onClick={() => {
                        handleEditPeople(people);
                      }}
                    />
                    <DeleteIcon
                      onClick={() => {
                        setActiveMember(people);
                        handleDelete();
                      }}
                      className='w-5 h-5 text-[#E60A2B] icon'
                    />
                  </div>
                </div>
              </TableData>
            </TableRow>
          ))}
        </Table>
      )}
      <DeletePeople
        onClose={() => {
          setShowDeleteModal(false);
        }}
        show={showDeleteModal}
        selectedPeople={selectedPeople}
        activeMember={activeMember}
        setSelectedPeople={setSelectedPeople}
        removeMembers={removeMembers}
      />
      <BudgetSettingModal
        isOpen={showBudgetSettingsModal}
        onClose={() => setShowBudgetSettingsModal(false)}
        selectedPeople={selectedPeople}
        setSelectedPeople={setSelectedPeople}
        updateMembers={updateMembers}
      />
      <MemberDetails
        isOpen={showDetailModal}
        onClose={() => setShowDetailModal(false)}
        singlePeople={singlePeople}
        setSelectedPeople={setSelectedPeople}
        updatePerson={updatePerson}
        onRefresh={() => fetchAllMembersList()}
        previousPage={searchParams.get('from') ?? ''}
      />
      <GiftSelectedMemberModal
        isOpen={showGiftModal}
        onClose={() => setShowGiftModal(false)}
        singlePeople={singlePeople}
      />
      {selectedPeople.length !== 0 && (
        <PeopleTableBulkActions
          people={selectedPeople}
          deleteFunc={handleDelete}
          selectAllFunc={toggleAll}
          showBulkActions={showBulkActions}
          setShowBulkActions={setShowBulkActions}
          setSelectedPeople={setSelectedPeople}
          setShowBudgetSettingsModal={setShowBudgetSettingsModal}
        />
      )}
    </div>
  );
};

export default People;
